import moment from "moment";
import {
  GET_SHIPPING_CHARGE,
  SET_PAGE,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialShippingCharge = {
  shippingCharge: [],
  shippingChargeCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

function shippingChargeReducer(state = initialShippingCharge, action) {
  switch (action.type) {
    case GET_SHIPPING_CHARGE:
      return {
        ...state,
        shippingCharge: action.payload.shipping_charges.map((charge) => {
          return {
            ...charge,
            updatedAtFormatted: moment(charge.createdAt).format("ll"),
          };
        }),
        shippingChargeCount: action.payload.total,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };

    // case SET_SEARCH:
    //   return {
    //     ...state,
    //     search: action.payload,
    //   };
    default:
      return state;
  }
}

export default shippingChargeReducer;
